import { useCallback, useEffect, useMemo, useState } from 'react';
import { loadSavedMultiples, SAVED_MULTIPLES_STORAGE_KEY } from '@/utils/savedMultiples';

export function useSavedMultiples() {
  const [snapshots, setSnapshots] = useState(() => loadSavedMultiples());

  useEffect(() => {
    try {
      localStorage.setItem(SAVED_MULTIPLES_STORAGE_KEY, JSON.stringify(snapshots));
    } catch {
      /* quota */
    }
  }, [snapshots]);

  const addSnapshot = useCallback((snap) => {
    const id =
      snap.id || `mult-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    const row = {
      ...snap,
      id,
      createdAt: snap.createdAt || new Date().toISOString(),
    };
    setSnapshots((prev) => [row, ...prev]);
    return row;
  }, []);

  const removeSnapshot = useCallback((id) => {
    setSnapshots((prev) => prev.filter((s) => s.id !== id));
  }, []);

  const updateSnapshot = useCallback((id, patch) => {
    setSnapshots((prev) =>
      prev.map((s) => (s.id === id ? { ...s, ...patch } : s)),
    );
  }, []);

  const value = useMemo(
    () => ({ snapshots, addSnapshot, removeSnapshot, updateSnapshot }),
    [snapshots, addSnapshot, removeSnapshot, updateSnapshot],
  );

  return value;
}
